"use strict";

module.exports = require('./readable').Transform;